/*

  Datepicker
  https://flatpickr.js.org/getting-started/

 */

import flatpickr from "flatpickr";
import moment from "moment";
import 'moment/locale/ja';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index";
import "flatpickr/dist/plugins/monthSelect/style.css";
flatpickr.localize(Japanese);

$(function(){
    flatpickrSetting();
    flatpickrInputSetting();
    flatpickrMonthSetting();

    $(document).on('cocoon:after-insert', '.select2_fields', (e, elm) => {
        flatpickrSetting(elm);
        flatpickrMonthSetting(elm);
    });

    function flatpickrTargets(root, selector) {
        const $root = root ? $(root) : $(document);
        return $root.filter(selector).add($root.find(selector));
    }

    function flatpickrMonthSetting(root) {
        flatpickrTargets(root, '.js-flatpickr-month').each((i, element) => {
            if (element._flatpickr) {
                return;
            }

            flatpickr(element, {
                plugins: [
                    new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: "Y-m",
                        altFormat: "Y年m月",
                    })
                ],
                allowInput: true,
                disableMobile: true,

                // 年切り替えの<>ボタンが動作しないので、flatpickr側のclickハンドラを解除してから自前で実装
                onReady: (selectedDates, dateStr, instance) => {
                    const fp = instance;
                    const navEls = [fp.prevMonthNav, fp.nextMonthNav];

                    if (fp._handlers && navEls.some(el => el)) {
                        fp._handlers = fp._handlers.filter(h => {
                            if (navEls.includes(h.element) && h.event === "click") {
                                h.element.removeEventListener(h.event, h.handler);
                                return false;
                            }
                            return true;
                        });
                    }

                    if (fp.prevMonthNav) {
                        fp.prevMonthNav.addEventListener("click", (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fp.changeYear(fp.currentYear - 1);
                        });
                    }

                    if (fp.nextMonthNav) {
                        fp.nextMonthNav.addEventListener("click", (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fp.changeYear(fp.currentYear + 1);
                        });
                    }
                }
            });
        });
    }

    function flatpickrSetting(root) {
      flatpickrTargets(root, '.flatpickr').each((i, element) => {
          if (element._flatpickr) {
              return;
          }

          flatpickr(element, {
              clickOpens: false,
              altInput: false,
              altFormat: 'YYYY-MM-DD',
              dateFormat: "YYYY-MM-DD",
              parseDate: (datestr, format) => {
                  return moment(datestr, format, true).toDate();
              },
              formatDate: (date, format, locale) => {
                  // locale can also be used
                  return moment(date).format(format);
              },
              allowInput: true,
              wrap: true,
              disableMobile: true,
          });
      });
    }

    function seireki(warekiYear) {
        var matches = warekiYear.match('^(明治|大正|昭和|平成|令和)([元0-9０-９]+)$');
        if(matches) {
            var eraName = matches[1];
            var year = parseInt(matches[2].replace(/[元０-９]/g, function(match){
                if(match === '元') {
                    return 1;
                }
                return String.fromCharCode(match.charCodeAt(0) - 65248);
            }));
            if(eraName === '明治') {
                year += 1867;
            } else if(eraName === '大正') {
                year += 1911;
            } else if(eraName === '昭和') {
                year += 1925;
            } else if(eraName === '平成') {
                year += 1988;
            } else if(eraName === '令和') {
                year += 2018;
            }
            return year;
        }
        return null;
    }

    function flatpickrInputSetting() {
      $(document).off('change.flatpickrInput', '.flatpickr-input').on('change.flatpickrInput', '.flatpickr-input', function(){
        let s = $(this).val();
        const date_regex = /(\d{4})\/(\d{1,2})\/(\d{1,2})/
        const date_regex_jp = /(\D+)+(\d+)年(\d+)月(\d+)日/
        if (s.match( date_regex )) {
          let r = s.match( date_regex );
          r[2] = ('0' + r[2]).slice(-2);
          r[3] = ('0' + r[3]).slice(-2);
          let result = r[1] + '-' + r[2] + '-' + r[3];
          let dt = new Date(r[1], r[2]-1, r[3] );
          $(this).val(result);
          let warekiElement = document.createElement('p');
          warekiElement.className = 'wareki';
          warekiElement.textContent = dt.toLocaleDateString('ja-JP-u-ca-japanese', {era:'long'});
          $(this).parent().parent().find('.wareki').remove();
          $(this).parent().parent().append(warekiElement);
        } else if (s.match( date_regex_jp )) {
          let r = s.match( date_regex_jp );
          r[3] = ('0' + r[3]).slice(-2);
          r[4] = ('0' + r[4]).slice(-2);
          let wa = r[1] + r[2];
          let tmp = seireki(wa);
          let result = tmp + '-' + r[3] + '-' + r[4];
          let dt = new Date(r[1], r[2]-1, r[3] );
          $(this).val(result);
          let warekiElement = document.createElement('p');
          warekiElement.className = 'wareki';
          warekiElement.textContent = dt.toLocaleDateString('ja-JP-u-ca-japanese', {era:'long'});
          $(this).parent().parent().find('.wareki').remove();
          $(this).parent().parent().append(warekiElement);
        } else if (s.match( date_regex )) {
          let r = s.match( date_regex);
          r[2] = ('0' + r[2]).slice(-2);
          r[3] = ('0' + r[3]).slice(-2);
          let result = r[1] + '-' + r[2] + '-' + r[3];
          let dt = new Date(r[1], r[2]-1, r[3] );
          $(this).val(result);
          let warekiElement = document.createElement('p');
          warekiElement.className = 'wareki';
          warekiElement.textContent = dt.toLocaleDateString('ja-JP-u-ca-japanese', {era:'long'});
          $(this).parent().parent().find('.wareki').remove();
          $(this).parent().parent().append(warekiElement);
        } else {
          $(this).parent().parent().find('.wareki').remove();
        }
      });
    }

    // ②-1: Tab/Enterで日付欄の値を確定する直前に、スラッシュ区切り（2024/1/1）やゼロ埋め
    // なしのハイフン区切り（2024-1-1）、区切りなし8桁（20240101）、和暦表記
    // （令和6年1月1日）をYYYY-MM-DD形式へ正規化しておく。flatpickr自身がこの直後（Tabなら
    // blur、EnterならkeydownでflatpickrがsetDateを呼ぶ）に入力値を厳密フォーマット
    // （YYYY-MM-DD固定）で再パースし、形式が一致しないと入力値をクリアしてしまうため、
    // その前に正しい形式へ揃えることでクリアされるのを防ぐ（クライアント確認済み・修正依頼）。
    function normalizeManualDateText(str) {
        const date_regex = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
        const date_regex_hyphen = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
        const date_regex_compact = /^(\d{4})(\d{2})(\d{2})$/;
        const date_regex_jp = /^(\D+)(\d+)年(\d+)月(\d+)日$/;
        let r = str.match(date_regex);
        if (r) {
            return r[1] + '-' + ('0' + r[2]).slice(-2) + '-' + ('0' + r[3]).slice(-2);
        }
        r = str.match(date_regex_hyphen);
        if (r) {
            return r[1] + '-' + ('0' + r[2]).slice(-2) + '-' + ('0' + r[3]).slice(-2);
        }
        r = str.match(date_regex_compact);
        if (r) {
            return r[1] + '-' + r[2] + '-' + r[3];
        }
        r = str.match(date_regex_jp);
        if (r) {
            const seirekiYear = seireki(r[1] + r[2]);
            if (seirekiYear) {
                return seirekiYear + '-' + ('0' + r[3]).slice(-2) + '-' + ('0' + r[4]).slice(-2);
            }
        }
        return null;
    }

    // documentのcapture段階で登録することで、flatpickr本体のkeydown処理
    // （window.document.bodyへbind、bubble段階）より必ず先に実行されるようにする。
    function flatpickrConfirmKeySetting() {
        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Tab' && e.key !== 'Enter') return;
            const target = e.target;
            if (!target || !target.classList || !target.classList.contains('flatpickr-input')) return;

            const normalized = normalizeManualDateText(target.value.trim());
            if (normalized) {
                target.value = normalized;
            }
        }, true);
    }
    flatpickrConfirmKeySetting();

    flatpickr('.jstp', {});
    flatpickr('#arr-cal', {
        onClose: function(selectedDates, dateStr, instance){
            if (dateStr) {
                location.href = "?date=" + dateStr;
            }
        }
    });
})
